import { redirect } from 'react-router'

import { isAuthenticated } from '@/resources/services/permission/auth'

export function requireAuth() {
  if (!isAuthenticated()) {
    // React Router data APIs use thrown Response redirects.
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- redirect() is the supported guard pattern
    throw redirect('/login')
  }

  return null
}
